/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationMoveInitResVo } from './AdminStockAdjustLocationMoveInitResVo';
import {
    AdminStockAdjustLocationMoveInitResVoFromJSON,
    AdminStockAdjustLocationMoveInitResVoFromJSONTyped,
    AdminStockAdjustLocationMoveInitResVoToJSON,
    AdminStockAdjustLocationMoveInitResVoToJSONTyped,
} from './AdminStockAdjustLocationMoveInitResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationMoveInitResVo
 */
export interface ResponseAdminStockAdjustLocationMoveInitResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationMoveInitResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationMoveInitResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationMoveInitResVo}
     * @memberof ResponseAdminStockAdjustLocationMoveInitResVo
     */
    data?: AdminStockAdjustLocationMoveInitResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationMoveInitResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationMoveInitResVo(value: object): value is ResponseAdminStockAdjustLocationMoveInitResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationMoveInitResVoFromJSON(json: any): ResponseAdminStockAdjustLocationMoveInitResVo {
    return ResponseAdminStockAdjustLocationMoveInitResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationMoveInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationMoveInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationMoveInitResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationMoveInitResVoToJSON(json: any): ResponseAdminStockAdjustLocationMoveInitResVo {
    return ResponseAdminStockAdjustLocationMoveInitResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationMoveInitResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationMoveInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationMoveInitResVoToJSON(value['data']),
    };
}

